(() => {
  if (customElements.get('kp-home-slideshow')) return;
  class HomeSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.index = 0;
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.onScreen = true;
      this.hovered = false;
      this.focused = false;
      const options = { signal: this.abort.signal };
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.addEventListener('keydown', event => {
        if (event.target === this && event.key === ' ') { event.preventDefault(); this.userPaused = !this.userPaused; this.schedule(); return; }
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      const rail = this.querySelector('.kph-slides');
      rail.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse') return;
        this.touch = { x: event.clientX, y: event.clientY };
        clearTimeout(this.timer);
      }, { ...options, passive: true });
      rail.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const x = event.clientX - this.touch.x, y = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.2) this.show(this.index + (x < 0 ? 1 : -1));
        else this.schedule();
      }, { ...options, passive: true });
      rail.addEventListener('pointercancel', () => { this.touch = null; this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.userPaused = true;
        this.schedule();
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index !== -1) { this.userPaused = true; this.show(index); }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.onScreen = entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
      this.show(0);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const inactive = i !== this.index;
        slide.hidden = inactive;
        slide.toggleAttribute('inert', inactive);
        slide.setAttribute('aria-hidden', String(inactive));
      });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length < 2 || this.userPaused || this.hovered || this.focused || !this.onScreen || document.hidden || this.touch) return;
      const delay = Math.max(5000, Math.min(10000, Number(this.dataset.interval) || 6000));
      this.timer = setTimeout(() => this.show(this.index + 1), delay);
    }
  }
  customElements.define('kp-home-slideshow', HomeSlideshow);
})();
